export default __webpack_public_path__ + "static/qsig-dc2f959ddc2df7736f18492ffc85a5d3.png";